<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 35 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8833 20.9647H18.0886M21.8833 17.1619H18.0886M10.4993 18.1126H4.80729M10.4993 14.3098H4.80729M10.4993 10.507H4.80729M25.678 24.7676V14.3098C25.678 13.2577 24.8305 12.4084 23.7806 12.4084H14.294M14.294 31.4225V7.43942C14.294 7.00844 13.9904 6.62816 13.573 6.52675L2.189 4.14366C1.91072 4.0676 1.60712 4.13098 1.36679 4.32112C1.13911 4.49859 1 4.77746 1 5.05633V35.2126H14.294M4.80729 4.68873V1"
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.9827 36.9995C19.3463 36.9995 18.736 36.8905 18.1519 36.6726C17.5766 36.4459 17.1014 36.1277 16.7266 35.718L18.2173 34.2534C18.3742 34.48 18.6053 34.6675 18.9104 34.8157C19.2242 34.9552 19.5511 35.0249 19.8911 35.0249C20.1963 35.0249 20.4578 34.9726 20.6757 34.868C20.9024 34.7547 21.0768 34.6021 21.1988 34.4103C21.3296 34.2098 21.395 33.9744 21.395 33.7042C21.395 33.4339 21.3296 33.1985 21.1988 32.998C21.0768 32.7975 20.898 32.6406 20.6627 32.5273C20.4273 32.4139 20.144 32.3573 19.8127 32.3573C19.5163 32.3573 19.2417 32.4009 18.9888 32.488C18.7447 32.5665 18.5224 32.6798 18.3219 32.828L18.5442 31.3373C18.7796 31.1978 18.9888 31.0801 19.1719 30.9842C19.355 30.8883 19.5468 30.8186 19.7473 30.775C19.9565 30.7314 20.2006 30.7096 20.4796 30.7096C21.1857 30.7096 21.7742 30.8535 22.245 31.1412C22.7244 31.4201 23.0862 31.795 23.3303 32.2657C23.5744 32.7278 23.6965 33.2378 23.6965 33.7957C23.6965 34.4234 23.5439 34.9813 23.2388 35.4695C22.9337 35.949 22.5021 36.3238 21.9442 36.5941C21.395 36.8643 20.7411 36.9995 19.9827 36.9995ZM18.3219 32.828L17.4066 31.9911L17.8642 27.5843H19.9565L19.4727 31.8473L18.3219 32.828ZM18.1519 29.5327L17.8642 27.5843H23.1865V29.5327H18.1519Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M30.1449 27.2695C30.3719 27.2695 30.5765 27.4061 30.6637 27.6156L31.7209 30.1574L34.4649 30.3774C34.6912 30.3955 34.8843 30.548 34.9544 30.7638C35.0245 30.9797 34.9579 31.2165 34.7856 31.3642L32.6949 33.155L33.3336 35.8327C33.3863 36.0535 33.301 36.2843 33.1173 36.4177C32.9337 36.5511 32.6879 36.5609 32.4942 36.4426L30.1449 35.0077L27.7956 36.4426C27.6019 36.5609 27.3561 36.5511 27.1725 36.4177C26.9888 36.2843 26.9035 36.0535 26.9562 35.8327L27.5949 33.155L25.5042 31.3642C25.3319 31.2165 25.2652 30.9797 25.3354 30.7638C25.4055 30.548 25.5986 30.3955 25.8249 30.3774L28.5689 30.1574L29.6261 27.6156C29.7133 27.4061 29.9179 27.2695 30.1449 27.2695Z"
      :fill="color"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 64,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
